import React, { useState } from 'react';
import { 
  Table, Card, Form, Input, Select, Button, 
  DatePicker, Space, Typography, 
} from 'antd';
import { SearchOutlined, ReloadOutlined } from '@ant-design/icons';

const { RangePicker } = DatePicker;
const { Option } = Select;
const { Text, Title } = Typography;

const EnterpriseProducePurchase = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  // 模拟数据
  const mockData = [
    {
      key: '1',
      orderNo: 'EPA202603230001',
      enterpriseName: '微网优联科技（成都）有限公司',
      enterpriseId: 'QEBcW6rqyCMIOVUL',
      productName: '智能摄像机 Q1',
      productId: 'PROD_001',
      quantity: 5000,
      price: 15.50,
      totalAmount: 77500.00,
      purchaseTime: '2026-03-23 11:20:02',
      workOrderName: 'Q1成都工厂首批次',
      workOrderId: 'WO_ENT_20260323_01'
    },
    {
      key: '2',
      orderNo: 'EPA202603220055',
      enterpriseName: '东莞康林物联网有限公司',
      enterpriseId: 'JGSf0Nd7',
      productName: '双目室外机 W2',
      productId: 'PROD_W2',
      quantity: 1200,
      price: 45.00,
      totalAmount: 54000.00,
      purchaseTime: '2026-03-22 15:45:10',
      workOrderName: 'W2东莞生产计划',
      workOrderId: 'WO_ENT_20260322_09'
    }
  ];

  const columns = [
    {
      title: '订单编号',
      dataIndex: 'orderNo',
      key: 'orderNo',
      width: 180,
    },
    {
      title: '企业信息',
      key: 'enterpriseInfo',
      width: 220,
      render: (_, record) => (
        <div>
          <div style={{ fontWeight: 500 }}>{record.enterpriseName}</div>
          <Text type="secondary" style={{ fontSize: 12 }}>ID: {record.enterpriseId}</Text>
        </div>
      )
    },
    {
      title: '产品信息',
      key: 'productInfo',
      width: 200,
      render: (_, record) => (
        <div>
          <div style={{ fontWeight: 500 }}>{record.productName}</div>
          <Text type="secondary" style={{ fontSize: 12 }}>ID: {record.productId}</Text>
        </div>
      )
    },
    {
      title: '采购数量',
      dataIndex: 'quantity',
      key: 'quantity',
      align: 'right',
      render: (val) => val.toLocaleString()
    },
    {
      title: '采购单价(CNY)',
      dataIndex: 'price',
      key: 'price',
      align: 'right',
      render: (val) => `¥${val.toFixed(2)}`
    },
    {
      title: '总价(CNY)',
      dataIndex: 'totalAmount',
      key: 'totalAmount',
      align: 'right',
      render: (val) => <Text strong>¥{val.toFixed(2)}</Text>
    },
    {
      title: '采购时间',
      dataIndex: 'purchaseTime',
      key: 'purchaseTime',
      width: 180,
    },
    // {
    //   title: '工单信息',
    //   key: 'workOrderInfo',
    //   width: 220,
    //   render: (_, record) => (
    //     <div>
    //       <div>{record.workOrderName}</div>
    //       <Text type="secondary" style={{ fontSize: 12 }}>ID: {record.workOrderId}</Text>
    //     </div>
    //   )
    // }
  ];

  const onReset = () => {
    form.resetFields();
  };

  const onSearch = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  return (
    <div style={{ padding: '24px' }}>
      <div style={{ marginBottom: 16 }}>
        <Title level={4}>企业生产采购</Title>
      </div>

      <Card style={{ marginBottom: 16 }}>
        <Form form={form} layout="inline">
          <Form.Item>
            <Space.Compact>
              <Form.Item name="entSearchType" initialValue="entName" noStyle>
                <Select style={{ width: 120 }}>
                  <Option value="entName">企业名称</Option>
                  <Option value="entId">企业ID</Option>
                </Select>
              </Form.Item>
              <Form.Item name="entSearchValue" noStyle>
                <Input placeholder="请输入企业信息" style={{ width: 180 }} allowClear />
              </Form.Item>
            </Space.Compact>
          </Form.Item>

          <Form.Item>
            <Space.Compact>
              <Form.Item name="searchType" initialValue="productName" noStyle>
                <Select style={{ width: 120 }}>
                  <Option value="productName">产品名称</Option>
                  <Option value="productId">产品ID</Option>
                </Select>
              </Form.Item>
              <Form.Item name="searchValue" noStyle>
                <Input placeholder="请输入产品信息" style={{ width: 180 }} allowClear />
              </Form.Item>
            </Space.Compact>
          </Form.Item>

          <Form.Item name="purchaseTime" label="采购时间">
            <RangePicker showTime />
          </Form.Item>

          <Form.Item>
            <Space>
              <Button type="primary" icon={<SearchOutlined />} onClick={onSearch}>
                查询
              </Button>
              <Button icon={<ReloadOutlined />} onClick={onReset}>
                重置
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>

      <Card>
        <Table
          columns={columns}
          dataSource={mockData}
          rowKey="key"
          loading={loading}
          pagination={{
            showTotal: (total) => `共 ${total} 条记录`,
            pageSize: 10,
          }}
        />
      </Card>
    </div>
  );
};

export default EnterpriseProducePurchase;
